import type { JSResourceOptions, Loader, PreloadableJSResourceReference } from '../../types';
import { createCache } from '../../utils';
import { PreloadableJSResource } from '../preloadable-js-resource';
import { postTask } from '../scheduler';

const cache = createCache(new Map<string, PreloadableJSResourceReference<any>>());

// JFP-6801: replace with RUNTIME_STRING_ERROR once react-async-transformer string rewrite ships.
const STRING_PATH_TEMPORARILY_DISABLED_JFP6801 =
	'JSResourceForInteraction: string import paths are not enabled yet (JFP-6801). ' +
	'Wait for the react-async-transformer change to ship, or use () => import("...") until then.';

export function JSResourceForInteraction<T = unknown>(
	path: string,
	opts?: JSResourceOptions,
): PreloadableJSResourceReference<T>;

export function JSResourceForInteraction<T = unknown>(
	loader: Loader<T>,
	opts?: JSResourceOptions,
): PreloadableJSResourceReference<T>;

export function JSResourceForInteraction<T = unknown>(
	loaderOrPath: Loader<T> | string,
	opts?: JSResourceOptions,
): PreloadableJSResourceReference<T> {
	// TODO: Temporary until the JFP-6802 transformer PR is merged. This currently blocks usage of raw string paths and will be removed as part of the transformer change PR.
	if (typeof loaderOrPath === 'string') {
		throw new Error(STRING_PATH_TEMPORARILY_DISABLED_JFP6801);
	}
	return cache.get(opts!.moduleId!, () =>
		PreloadableJSResource(() => postTask(loaderOrPath, { priority: 'user-visible' }), opts!),
	);
}
